import { createSelector } from 'reselect';

const innerStateSelector = state => state.wallet

const amountDataSelector = createSelector(
   innerStateSelector,
   state => state.amountData
);
const walletPaymentHistorySelector = createSelector(
   innerStateSelector,
   state => state.history
);
const isFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isFetching
);
const isFetchingHistorySelector = createSelector(
   innerStateSelector,
   state => state.isFetchingHistory
);
const isEmptyHistorySelector = createSelector(
   innerStateSelector,
   state => state.isEmptyHistory
);

const nextFetchingWalletHistorySelector = createSelector(
   innerStateSelector,
   state => state.isNextFetching
);

const walletLimitModalDataSelector = createSelector(
   innerStateSelector,
   state => state.walletLimitModalData
);

const purchaseStatusSelector = createSelector(
   innerStateSelector,
   state => state.purchaseStatus
);
const modalStateSelector = createSelector(
   innerStateSelector,
   (state) => (state.modalState)
);

export {
   amountDataSelector,
   walletPaymentHistorySelector,
   isFetchingSelector,
   isFetchingHistorySelector,
   isEmptyHistorySelector,
   nextFetchingWalletHistorySelector,
   walletLimitModalDataSelector,

   purchaseStatusSelector,
   modalStateSelector,
}
